import { FC } from 'react'
import { Link } from 'react-router-dom'
import { formatDateTime } from '../../../../../../../_metronic/helpers/crud-helper/helpers'
import { ModalSize } from '../../../../../../../_metronic/helpers/enumsUI'
import { PageHeading } from '../../../../../../components/Header/PageHeading'
import { Button } from '../../../../../../components/Button/Button'
import { useModal } from '../../../../../../components/Modal/ModalContext'
import { CondicaoCatalogo } from '../../../../formularios/core/condicao/catalogo'
import { CriarRascunhoButton } from '../../../acoes/CriarRascunhoButton'
import { PublicarModeloModal } from '../../../aprovacao/PublicarModeloModal'
import { useAcoesModelo } from '../../../core/useProtocoloAcoes'
import { CLASSE_LINK_OUTLINE } from '../../../core/classeLinkOutline'
import { SituacaoProtocoloBadge } from '../../../components/SituacaoProtocoloBadge'
import { ModeloVersaoDetalhe } from '../../../core/_models'

type Props = {
  versao: ModeloVersaoDetalhe
  catalogo?: CondicaoCatalogo
  onPublicado: () => void
}

/**
 * Cabeçalho da versão do modelo, acima do card: versão e nome como título; situação, origem e
 * publicação como apoio; ações à direita — "Publicar" é a principal quando a versão é rascunho.
 */
export const ModeloPlataformaDetalheHeading: FC<Props> = ({ versao, catalogo, onPublicado }) => {
  const { acoesModelo } = useAcoesModelo()
  const { showModal } = useModal()

  const podePublicar = versao.situacao === 'RASCUNHO' && acoesModelo.podePublicarModelo

  const abrirPublicacao = () =>
    showModal({
      title: `Publicar a versão ${versao.versao} do modelo`,
      size: ModalSize.Large,
      content: (
        <PublicarModeloModal versao={versao} catalogo={catalogo} onPublicado={onPublicado} />
      ),
    })

  const apoio = [
    versao.recursoCargaInicial && 'Carga inicial',
    versao.versaoOrigem && `Criada a partir da versão ${versao.versaoOrigem}`,
    versao.dtPublicacao && `Publicada em ${formatDateTime(versao.dtPublicacao)}`,
  ].filter(Boolean)

  return (
    <PageHeading
      title={`Versão ${versao.versao} — ${versao.nome}`}
      description={
        <span className='d-inline-flex flex-wrap align-items-center gap-3'>
          <SituacaoProtocoloBadge situacao={versao.situacao} escopo='modelo' />
          {apoio.length > 0 && <span>{apoio.join(' · ')}</span>}
        </span>
      }
      actions={
        <div className='d-flex flex-wrap align-items-center gap-3'>
          <Link
            className={CLASSE_LINK_OUTLINE}
            to={`/apps/protocolos-triagem/modelo-plataforma/${versao.id}/comparar`}
          >
            Comparar versões
          </Link>
          <CriarRascunhoButton
            escopo='modeloPlataforma'
            idOrigem={versao.id}
            podeCriarRascunho={acoesModelo.podeGerenciarModelo}
            aparencia={podePublicar ? 'secundaria' : 'principal'}
          />
          {podePublicar && (
            <Button className='btn-primary' onClick={abrirPublicacao}>
              Publicar
            </Button>
          )}
        </div>
      }
    />
  )
}
